import { useTranslation } from "react-i18next";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import ServicePageLayout from "./components/ServicePageLayout";
import { servicesOverview } from "@/mocks/services";

export default function EquipoEspecializadoPage() {
  const { t } = useTranslation("home");
  const data = servicesOverview.services.find((s) => s.slug === "equipo-especializado");

  return (
    <Layout>
      <SEO
        title="Equipo Especializado HVAC | Ventra Core León, Guanajuato"
        description="Implementación de sistemas HVAC en grandes proyectos con tecnología de vanguardia. Especialistas en espacios comerciales, industriales, hospitalarios y centros de datos en León, Guanajuato."
        keywords="equipo especializado HVAC, sistemas HVAC industriales, climatización hospitales, centros de datos León, HVAC comercial Guanajuato"
        canonical="https://ventracore.com.mx/equipo-especializado"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "@id": "https://ventracore.com.mx/equipo-especializado#service",
            "serviceType": "Equipo Especializado HVAC",
            "provider": { "@id": "https://ventracore.com.mx/#organization" },
            "areaServed": {
              "@type": "City",
              "name": "León",
            },
            "description": "Implementación de sistemas HVAC en grandes proyectos con tecnología de vanguardia en León, Guanajuato.",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Servicios",
                "item": "https://ventracore.com.mx/servicios",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Equipo Especializado",
                "item": "https://ventracore.com.mx/equipo-especializado",
              },
            ],
          },
        ]}
      />
      <ServicePageLayout
        title={t("servicesPage.equipmentTitle")}
        subtitle={t("servicesPage.equipmentSubtitle")}
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm md:text-base text-text-muted leading-relaxed text-center mb-10 md:mb-14">
            {t("servicesPage.equipmentDesc")}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            <div className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                  <i className="ri-building-line" />
                </span>
              </div>
              <h4 className="text-base font-bold text-magenta mb-2">
                {t("servicesPage.equipment.commercial")}
              </h4>
              <p className="text-sm text-text-muted leading-relaxed">
                {t("servicesPage.equipment.commercialDesc")}
              </p>
            </div>

            <div className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                  <i className="ri-building-4-line" />
                </span>
              </div>
              <h4 className="text-base font-bold text-magenta mb-2">
                {t("servicesPage.equipment.industrial")}
              </h4>
              <p className="text-sm text-text-muted leading-relaxed">
                {t("servicesPage.equipment.industrialDesc")}
              </p>
            </div>

            <div className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                  <i className="ri-hospital-line" />
                </span>
              </div>
              <h4 className="text-base font-bold text-magenta mb-2">
                {t("servicesPage.equipment.hospital")}
              </h4>
              <p className="text-sm text-text-muted leading-relaxed">
                {t("servicesPage.equipment.hospitalDesc")}
              </p>
            </div>

            <div className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                  <i className="ri-server-line" />
                </span>
              </div>
              <h4 className="text-base font-bold text-magenta mb-2">
                {t("servicesPage.equipment.datacenter")}
              </h4>
              <p className="text-sm text-text-muted leading-relaxed">
                {t("servicesPage.equipment.datacenterDesc")}
              </p>
            </div>
          </div>

          {data && (
            <div className="mt-10 md:mt-14 rounded-lg overflow-hidden">
              <img
                src={data.image}
                alt={data.title}
                className="w-full h-64 md:h-80 object-cover"
              />
            </div>
          )}

          <p className="text-sm text-text-muted text-center mt-8">
            {t("servicesPage.contact")}
          </p>
        </div>
      </ServicePageLayout>
    </Layout>
  );
}